import React, { useEffect } from 'react'
import Button from '../components/Button'
import Instructions from '../components/Instructions';
import CallForAction from '../components/CallForAction';


const steps = [
	{
		stepNumber: 1,
		title: "Pick Website to Monetize",
		description:
			"Before interacting with Billboard, you must decide that you want to monetize your website. Pick out a place where you would like to run Ads. Make sure your website is up and running with maximum availability.",
	},
	{
		stepNumber: 2,
		title: "Register Publisher",
		description:
			"Connect your wallet to Billboard. Navigate to Publisher portal and register your website by providing Publisher name and link to the website which will run Ads.",
	},
	{
		stepNumber: 3,
		title: "Configure time-bins",
		description:
			"Your website’s advertising time will be split up into time slots during which ads will be shown. Those time slots will have corresponding auctions which Ads will bid on. You have to consider the frequency of your publishers time slots, and configure them in Billboard.",
	},
	{
		stepNumber: 4,
		title: "Accept Ad Campaigns",
		description:
			"Navigate to the Publisher portal and view pending Ad Campaigns. Consider carefully which Ad Campaigns you want to be publishing. Accept the ones you are willing to host.",
	},
];

const PublisherInfoPage = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [])
	return (
		<>
			<section className="flex md:yellow-elipse justify-center self-stretch pt-64 pb-48 max-md:mt-10 max-md:py-0" >
				<div className="flex flex-row gap-5 max-md:flex-col max-md:gap-0">
					<div className="w-6/12 max-md:w-full">
						<div className="flex flex-col grow justify-center px-5 py-4 font-bold max-w-[615px] max-md:mt-10 max-md:max-w-full">
							<h1 className="text-5xl bg-clip-text leading-[72px] max-md:max-w-full text-white max-md:text-4xl max-md:leading-[67px]">
								Decentralized SSP
							</h1>
							<p className="mt-12 text-2xl leading-9 text-zinc-400 max-md:mt-10 max-md:max-w-full">
								Looking to monetize your website, but dont want to go thought the hassle of onboarding with bid tech?

								Billboard offers the quickest way to start earning with advertisements.
							</p>
							<Button to={"/app/"} className="self-start mt-12 max-md:mt-10 w-72 text-white" background='linear-gradient(62deg, #6100FF 0%, #00FFD1 100%)'>Monetize Website</Button>
						</div>
					</div>
					<div className="w-6/12 max-md:w-full">
						<img
							loading="lazy"
							src={"./assets/publisherTeaserImage.png"}
							alt="Hero"
							className="rounded-3xl w-full aspect-[1.05] max-md:mt-10 max-md:max-w-full"
						/>
					</div>
				</div>
			</section>
			<section className="flex justify-center py-10 self-stretch bg-neutral-800 bg-opacity-50 max-md:px-5 max-md:mt-10 ">
				<Instructions heading={"Become a Publisher on  Solana backed Ad Exchange"} steps={steps} />
			</section>
			<CallForAction />
		</>
	)
}

export default PublisherInfoPage